export {};

let $galleries;

$(preInit);

function preInit() {
    $galleries = $('.justified-gallery');

    if ($galleries.length) {
        require.ensure(
            ['./module'],
            () => {
                const { init } = require('./module');

                init($galleries);
            },
            'justified-gallery',
        );
    }
}



// WEBPACK FOOTER //
// ./js/main/module/free-gallery/index.js